import {ApiError} from "../api";

type ErrorBody = {
  message?: string;
  title?: string;
  detail?: string;
  errors?: Record<string, string[] | string>;
};

// Ответы станции приходят с сервера по-английски — переводим известные
const translate = (text: string): string => {
  const timeout = /^Command '.*' received device timeout'?$/i;
  if (timeout.test(text)) return "станция не ответила вовремя";

  const deviceError = /^Command '.*' received error: '(.*)'$/i.exec(text);
  if (deviceError) return `станция вернула ошибку: ${deviceError[1]}`;

  const length = /^The field (\w+) must be a string or collection type with a minimum length of '(\d+)' and maximum length of '(\d+)'\.?$/i
    .exec(text);
  if (length) {
    return length[2] === length[3]
      ? `в поле ${length[1]} должно быть ровно ${length[2]} элемента(ов)`
      : `в поле ${length[1]} должно быть от ${length[2]} до ${length[3]} элементов`;
  }

  const required = /^The (\w+) field is required\.?$/i.exec(text);
  if (required) return `не заполнено поле ${required[1]}`;

  return text;
};

const STATUS_TEXT: Record<number, string> = {
  400: "сервер отклонил запрос",
  401: "нужно войти заново",
  403: "нет доступа",
  404: "не найдено",
  409: "конфликт данных",
  422: "станция не выполнила команду",
  500: "внутренняя ошибка сервера",
  502: "сервер недоступен",
  503: "сервер недоступен",
  504: "сервер не ответил вовремя",
};

/**
 * Причина ошибки запроса к API для показа пользователю: текст сервера (message, ошибки проверки),
 * иначе — по коду ответа
 */
export const getApiErrorReason = (error: unknown): string | null => {
  if (error instanceof ApiError) {
    const body = (typeof error.body === "object" && error.body !== null ? error.body : {}) as ErrorBody;

    if (body.errors) {
      const messages = Object.values(body.errors)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .filter(Boolean)
        .map(translate);
      if (messages.length > 0) return messages.join("; ");
    }

    if (body.message) return translate(body.message);
    if (body.detail) return translate(body.detail);
    if (typeof error.body === "string" && error.body.trim()) return translate(error.body.trim());

    return `${STATUS_TEXT[error.status] ?? "ошибка сервера"} (код ${error.status})`;
  }

  if (error instanceof TypeError) return "нет связи с сервером";
  if (error instanceof Error && error.message) return translate(error.message);

  return null;
};

/**
 * «Ошибка при …: причина»
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const reason = getApiErrorReason(error);
  return reason ? `${fallback}: ${reason}` : fallback;
};
